
import $ from 'jquery';
import Wishlist from './../libs/Wishlist.js'

import {getSessionToken} from './Util.js';

$( document ).ready( function() {

	// Set global Session Token, if not set already.
	if ( ! window._stoken ) {
		window._stoken = getSessionToken();
	}

	document.addEventListener( 'click', ( ev ) => {
		const buttonEl = ev.target.closest( '.js_toggle_wishlistproduct' );
		if ( buttonEl ) {
			ev.preventDefault();

			const articleId = buttonEl.getAttribute( 'data-aid' );
			const isOnWishlist = buttonEl.classList.contains( 'is-on-wishlist' );

			Wishlist.addArticle( articleId, isOnWishlist ? 0 : 1 )
				.then( ( data ) => {

					const items = data.items || [];
					const found = Wishlist.hasArticle( articleId );
					buttonEl.classList.toggle( 'is-on-wishlist', !! found );
				} );
		}
	} );

	document.addEventListener( 'click', ( ev ) => {
		const buttonEl = ev.target.closest( '.js_remove_wishlistproduct' );
		if ( buttonEl ) {
			ev.preventDefault();

			const articleId = buttonEl.getAttribute( 'data-aid' );

			Wishlist.addArticle( articleId, 0 )
				.then( ( data ) => {
					location.reload();
				} );
		}
	} );
} );

// Preload Article Cache.
Wishlist.getArticles();

// Expose Wishlist in global scope.
window.AclWishlist = Wishlist;

export default Wishlist;
